import { useSelector } from "react-redux"
import { RootState } from "store"

export const useGetCampaignDataById = (campaignId: string) => {
    return useSelector((state: RootState) => state.campaigns.items[campaignId]?.data?.campaign)
}